module.exports = __webpack_public_path__ + "img/home.032a3e9e.png";